var map = {
	"./bw-1.png": 47020,
	"./bw-10.png": 84820,
	"./bw-2.png": 13844,
	"./bw-3.png": 47590,
	"./bw-4.png": 24273,
	"./bw-5.png": 26163,
	"./bw-6.png": 70158,
	"./bw-7.png": 7445,
	"./bw-8.png": 14808,
	"./bw-9.png": 15946
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53405;